export enum TranslationKey {

    aboutToBeBlocked = "aboutToBeBlocked",
    acceptedCurrency = "acceptedCurrency",
    accountNumber = "accountNumber",
    additionalPaymentMethods = "additionalPaymentMethods",
    amount = "amount",
    apply = "apply",
    approved = "approved",
    back = "back",
    backToTrade = "backToTrade",
    bankAddress = "bankAddress",
    bankName = "bankName",
    beneficiaryName = "beneficiaryName",
    cancel = "cancel",
    cancelRequest = "cancelRequest",
    cardNumberWrong = "cardNumberWrong",
    choosePreferredBankCurrency = "choosePreferredBankCurrency",
    chooseYourPaymentMethod = "chooseYourPaymentMethod",
    chooseYourProvider = "chooseYourProvider",
    clientDeclaration = "clientDeclaration",
    completeLater = "completeLater",
    completed = "completed",
    confirm = "confirm",
    continueWith = "continueWith",
    continue_ = "continue_",
    creditCard = "creditCard",
    creditCardNumber = "creditCardNumber",
    creditCardType = "creditCardType",
    currency = "currency",
    cvvInfo = "cvvInfo",
    date = "date",
    dateOfBirth = "dateOfBirth",
    deposit = "deposit",
    depositAmount = "depositAmount",
    depositMinAmount = "depositMinAmount",
    depositPageSubtitleDepositSuccessful = "deposit.page.subtitle.DepositSuccessful",
    depositPageSubtitleDepositTopUp = "deposit.page.subtitle.DepositTopUp",
    depositPageTitleDepositSuccessful = "deposit.page.title.DepositSuccessful",
    depositPageTitleDepositTopUp = "deposit.page.title.DepositTopUp",
    depositPaymentMethodAstroPay = "deposit.payment.method.astroPay",
    depositPaymentMethodEasyEFT = "deposit.payment.method.easyEFT",
    depositPaymentMethodEcoPayz = "deposit.payment.method.ecoPayz",
    depositPaymentMethodEcoVoucher = "deposit.payment.method.ecoVoucher",
    depositPaymentMethodGlobePay = "deposit.payment.method.globePay",
    depositPaymentMethodKlarna = "deposit.payment.method.klarna",
    depositPaymentMethodMastercard = "deposit.payment.method.mastercard",
    depositPaymentMethodNeteller = "deposit.payment.method.neteller",
    depositPaymentMethodPaypal = "deposit.payment.method.paypal",
    depositPaymentMethodPsc = "deposit.payment.method.psc",
    depositPaymentMethodSafetyPay = "deposit.payment.method.safetyPay",
    depositPaymentMethodSkrill = "deposit.payment.method.skrill",
    depositPaymentMethodSofort = "deposit.payment.method.sofort",
    depositPaymentMethodTapPayments = "deposit.payment.method.tapPayments",
    depositPaymentMethodTrustly = "deposit.payment.method.trustly",
    depositPaymentMethodVisa = "deposit.payment.method.visa",
    depositPaymentMethodWireTransfer = "deposit.payment.method.wireTransfer",
    depositPaymentMethodZimpler = "deposit.payment.method.zimpler",
    documentTitleDepositSuccessful = "document.title.DepositSuccessful",
    documentTitleDepositTopUp = "document.title.DepositTopUp",
    expirationDate = "expirationDate",
    expiryDate = "expiryDate",
    formFieldCardCvv = "form.field.cardCvv",
    formFieldCardExpirationMonth = "form.field.cardExpirationMonth",
    formFieldCardExpirationYear = "form.field.cardExpirationYear",
    formFieldCardName = "form.field.cardName",
    formFieldCardNumber = "form.field.cardNumber",
    formFieldErrorAmount = "form.field.error.amount",
    formFieldErrorCardCvv = "form.field.error.cardCvv",
    formFieldErrorCardExpirationMonth = "form.field.error.cardExpirationMonth",
    formFieldErrorCardExpirationYear = "form.field.error.cardExpirationYear",
    formFieldErrorCardName = "form.field.error.cardName",
    formFieldErrorCardNumber = "form.field.error.cardNumber",
    formFieldMonth = "form.field.month",
    formFieldYear = "form.field.year",
    fullName = "fullName",
    goToPlatform = "goToPlatform",
    gotIt = "gotIt",
    great = "great",
    guaranteedSafe = "guaranteedSafe",
    iAgree = "iAgree",
    iAgreeTo = "iAgreeTo",
    iban = "iban",
    importantNotice = "importantNotice",
    leave = "leave",
    liveChat = "liveChat",
    mmYY = "mmYY",
    next = "next",
    nextStep = "nextStep",
    no = "no",
    ok = "ok",
    optional = "optional",
    or = "or",
    pending = "pending",
    pendingApproval = "pendingApproval",
    personalReferenceNumber = "personalReferenceNumber",
    pleaseSpecifyReason = "pleaseSpecifyReason",
    poweredBy = "poweredBy",
    print = "print",
    proceed = "proceed",
    readServiceAgreement = "readServiceAgreement",
    reason = "reason",
    receiptNumber = "receiptNumber",
    referenceNumberDescription = "referenceNumberDescription",
    reject = "reject",
    rejected = "rejected",
    replaceFile = "replaceFile",
    required = "required",
    scrollBottomToAcceptTerms = "scrollBottomToAcceptTerms",
    select = "select",
    sendDetailsViaEmail = "sendDetailsViaEmail",
    serverErrorGeneral = "server.error.general",
    serviceAgreement = "serviceAgreement",
    specifiedPepUs = "specifiedPepUs",
    start = "start",
    submit = "submit",
    submitCNMV = "submitCNMV",
    swift = "swift",
    termsAndConditions = "termsAndConditions",
    topUp = "topUp",
    topUpAgain = "topUpAgain",
    topUpDifferentAmount = "topUpDifferentAmount",
    topUpYourAccount = "topUpYourAccount",
    transactionId = "transactionId",
    transferDetailsSentToEmail = "transferDetailsSentToEmail",
    tryAgain = "tryAgain",
    upload = "upload",
    uploadAll = "uploadAll",
    uploadFile = "uploadFile",
    weReallySorry = "weReallySorry",
    willDoLater = "willDoLater",
    willTryLater = "willTryLater",
    yes = "yes",
}
